const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-section">
            <div className="footer-inner">
                <div className="footer-section-links">
                    <div className="footer-section-link">
                        <img src={`${process.env.PUBLIC_URL}/assets/instagram.png`} alt="Instagram" loading="lazy" />
                        <a href="https://www.instagram.com/healandthrivewithsiri" target="_blank" rel="noreferrer">
                            @healandthrivewithsiri
                        </a>
                    </div>
                    <div className="footer-section-link">
                        <img src={`${process.env.PUBLIC_URL}/assets/email.svg`} alt="Email" loading="lazy" />
                        <a href="mailto:officeofvidyasireesha@gmail.com" target="_blank" rel="noreferrer">
                            officeofvidyasireesha@gmail.com
                        </a>
                    </div>
                </div>
                <p className="text-sm text-grey-500 text-center">
                    &copy; {currentYear} Vidya Sireesha. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
